export const imagebossUrl = (imageUrl, dimensions) => {
  const { width, height } = dimensions;

  // Is probably already an imageboss url with dimensions specified. It will be
  // for block preview.
  if (imageUrl?.match(/imageboss.*(width|height|cover)\/\d/)) return imageUrl;

  if (!imageUrl?.includes(':dimensions')) {
    imageUrl = `https://img.imageboss.me/:dimensions/${imageUrl}`;
  }

  // ensure .gif extention if the image is supposed to be animated
  if (imageUrl?.includes('animation:true')) {
    // This regex will return a file extension if there is one. If it does not
    // have a file extension we need to add .gif
    const match = imageUrl.match(/\.(\w+)(?:\?.*)?$/);
    if (!match[0]) {
      imageUrl = `${imageUrl}.gif`;
    }
  }

  let urlDimensions;
  if (!!width && !!height) {
    // Imageboss says this will use the Shannon Entropy Algorithm to crop the
    // image to the center of it's content.
    urlDimensions = `cover:entropy/${width}x${height}`;
  } else if (!width) {
    urlDimensions = `height/${height}`;
  } else if (!height) {
    urlDimensions = `width/${width}`;
  }

  return imageUrl.replace(':dimensions', urlDimensions);
};
